"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.filter.js");
require("core-js/modules/es.iterator.for-each.js");
require("core-js/modules/es.iterator.map.js");
var _cookie = require("@/utils/cookie");
var _log = require("@/utils/log");
var _utils = require("@/utils");
var _subscriptions = require("@/api/subscriptions");
var _organizations = require("@/api/organizations");
var _index = _interopRequireDefault(require("@/components/SearchBox/index.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'SubscriptionList',
  components: {
    SearchBox: _index.default
  },
  data() {
    return {
      tableLoading: false,
      query: {
        q: ''
      },
      page: 1,
      limit: 10,
      total: 0,
      organizationsMap: null,
      subscriptionList: [],
      allSubscriptions: []
    };
  },
  computed: {
    pagedSubscriptionList() {
      return this.subscriptionList;
    }
  },
  created() {
    this.fetchSubscriptions();
  },
  methods: {
    search(page = 1) {
      this.page = page;
      this.fetchSubscriptions();
    },
    fetchSubscriptions() {
      const token = (0, _cookie.getCookie)('ACCESS_TOKEN');
      this.tableLoading = true;
      if (token) {
        Promise.resolve().then(() => {
          if (this.organizationsMap) {
            return Promise.resolve();
          }
          return (0, _organizations.getAllOrganizations)(token).then(response => {
            const map = {};
            if (response.data && response.data.rows) {
              response.data.rows.forEach(org => {
                map[org.id] = org.name;
              });
            }
            this.organizationsMap = map;
          }).catch(err => {
            (0, _log.showDebugLog)('getAllOrganizations-error', err);
            this.organizationsMap = {};
          });
        }).then(() => {
          const queryParams = {
            page: this.page,
            limit: this.limit
          };
          if (this.query.q) {
            queryParams.q = this.query.q;
          }
          return (0, _subscriptions.getSubscriptionList)(token, queryParams).then(response => {
            const rows = response.data.rows || [];
            this.subscriptionList = rows.map(item => ({
              id: item.id,
              tenant: (0, _utils.getTenantLabel)(item.metadata ? item.metadata.tenant : ''),
              organization: this.organizationsMap[item.organizationId] || item.organizationId || '',
              title: item.title
            }));
            this.total = response.data.count || this.subscriptionList.length;
            this.tableLoading = false;
          });
        }).catch(error => {
          (0, _log.showDebugLog)('getSubscriptionList-error', error);
          this.loadMockSubscriptions();
        });
      } else {
        this.loadMockSubscriptions();
      }
    },
    loadMockSubscriptions() {
      let list = this.allSubscriptions;
      if (this.query.q) {
        const q = this.query.q.toLowerCase();
        list = list.filter(item => item.title && item.title.toLowerCase().includes(q) || item.id && item.id.toLowerCase().includes(q) || item.tenant && item.tenant.toLowerCase().includes(q) || item.organization && item.organization.toLowerCase().includes(q));
      }
      const start = (this.page - 1) * this.limit;
      const end = start + this.limit;
      this.subscriptionList = list.slice(start, end);
      this.total = list.length;
      this.tableLoading = false;
    },
    handleSizeChange(val) {
      this.limit = val;
      this.page = 1;
      this.fetchSubscriptions();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.fetchSubscriptions();
    }
  }
};